/*
 * Copyright (C) 2022 IHS Markit.
 * All Rights Reserved
 *
 * NOTICE: All information contained herein is, and remains
 * the property of IHS Markit and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to IHS Markit and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from IHS Markit.
 */

import {ScreenerFilter} from '../modals/ScreenerFilter';
import {Filters} from '../modals/Filters';

export class AddFilter {
  static readonly type = '[ScreenerFilter] Add';

  constructor(public payload: ScreenerFilter) {
  }
}


export class UpdateFilter {
  static readonly type = '[ScreenerFilter] Update';

  constructor(public payload: Filters) {
  }
}

export class SavePageNumber {
  static readonly type = '[Number] SavePageNumber';

  constructor(public payload: number) {
  }
}

export class SaveStateName{
  static readonly type = '[String] SaveStateName';

  constructor(public payload: string) {
  }
}
